module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_3_3.ce2e6a4e.png";